/**
 * Loading Fallback Component — Sprint 2: Skeletron Screen
 * 
 * Mostra un'anteprima shimmer del contenuto invece di uno spinner.
 * L'utente percepisce che qualcosa sta "arrivando" anziché "aspettare".
 * Pattern: shimmer cards che imitano la struttura della dashboard.
 */
import React from 'react';

function ShimmerBlock({ className = '' }: { className?: string }) {
  return (
    <div className={`skeleton-shimmer rounded-lg ${className}`} />
  );
}

export default function LoadingFallback() {
  return (
    <div className="fixed inset-0 bg-black overflow-hidden">
      {/* Header shimmer */}
      <div className="px-4 pt-12 pb-4 border-b border-white/[0.14]">
        <div className="flex items-center gap-4">
          <ShimmerBlock className="w-20 h-20 rounded-full" />
          <div className="flex-1 space-y-3">
            <ShimmerBlock className="h-4 w-28" />
            <ShimmerBlock className="h-8 w-48" />
          </div>
        </div>
      </div>

      {/* Stats cards shimmer */}
      <div className="px-4 pt-6 space-y-4">
        <ShimmerBlock className="h-5 w-40" />
        <div className="grid grid-cols-2 gap-3">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="bg-white/[0.02] border border-white/[0.20] rounded-xl p-4 space-y-3">
              <ShimmerBlock className="h-8 w-8 rounded-lg" />
              <ShimmerBlock className="h-6 w-16" />
              <ShimmerBlock className="h-3 w-24" />
            </div>
          ))}
        </div>
      </div>

      {/* Tools cards shimmer */}
      <div className="px-4 pt-6 space-y-4">
        <ShimmerBlock className="h-5 w-44" />
        <div className="grid grid-cols-2 gap-3">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="bg-white/[0.02] border border-white/[0.20] rounded-xl p-4 space-y-3">
              <ShimmerBlock className="h-8 w-8 rounded-lg" />
              <ShimmerBlock className="h-5 w-24" />
              <ShimmerBlock className="h-3 w-full" />
            </div>
          ))}
        </div>
      </div>

      {/* Bottom branding */}
      <div className="absolute bottom-8 left-0 right-0 text-center">
        <p className="text-sm font-bold text-white/20 tracking-widest">RideConnect</p>
      </div>
    </div>
  );
}
// @keyframes fadeIn {
//   from { opacity: 0; }
//   to { opacity: 1; }
// }
// .animate-fadeIn {
//   animation: fadeIn 0.3s ease-in;
// }
